module.exports = __webpack_public_path__ + "static/covid-19-3-d0cbc962e74b330045510f689005cc2f.jpg";